<template>
  <header class="banner" role="banner">
    <nav role="navigation" class="wrapper">
      <router-link to="/" class="brand">
        <inline-svg :src="require('@/assets/logo-society.svg')" />
      </router-link>

      <button
        @click="toggleMenu"
        class="menu-toggle"
        :aria-expanded="menuOpen ? true : false"
        aria-controls="main-menu"
      >
        <FontAwesomeIcon :icon="menuOpen ? close : bars" />
      </button>

      <nav class="user-menu">
        <router-link
          v-if="isLoggedIn && user.roles.includes('member')"
          :to="`/members/${user.slug}`"
          >My Profile</router-link
        >
        <router-link
          v-if="isLoggedIn && user.roles.includes('sponsor')"
          :to="`/sponsors/${user.slug}`"
          >My Profile</router-link
        >
        <router-link v-if="isLoggedIn" to="/logout">Logout</router-link>
      </nav>

      <nav class="main-menu" :class="{ open: menuOpen }" id="main-menu">
        <router-link v-if="isLoggedIn" to="/members">Members</router-link>
        <router-link v-if="isLoggedIn" to="/sponsors">Sponsors</router-link>
        <router-link v-if="isLoggedIn" to="/events">Events</router-link>

        <div
          class="sub-menu"
          v-if="isLoggedIn"
          @mouseenter="toggleSubMenu('resources', true)"
          @mouseleave="toggleSubMenu('resources', false)"
          aria-haspopup="true"
          :aria-expanded="subMenuOpen['resources']"
        >
          <router-link to="/resources">Resources</router-link>

          <nav
            :class="{ open: subMenuOpen['resources'] }"
            class="sub-menu-links"
            aria-label="Resources Submenu"
          >
            <router-link to="/resources/forum">Forum</router-link>
            <router-link to="/resources/moderator">Moderator</router-link>
            <router-link to="/resources/mentorship">Mentorship</router-link>
            <router-link
              v-if="
                user.roles.includes('board_members') ||
                user.roles.includes('administrator')
              "
              to="/resources/verification"
              >Verification</router-link
            >
            <router-link
              v-if="
                user.roles.includes('board_members') ||
                user.roles.includes('administrator')
              "
              to="/resources/sponsorship"
              >Sponsorship</router-link
            >
          </nav>
        </div>
        <router-link v-if="isLoggedIn" to="/marketplace"
          >Marketplace</router-link
        >
        <router-link
          v-if="
            isLoggedIn &&
            (user.roles.includes('member') ||
              user.roles.includes('administrator'))
          "
          to="/deal-flow"
          >Deal Flow</router-link
        >

        <router-link v-if="!loading && !isLoggedIn" to="/login" class="btn"
          >User Login</router-link
        >
      </nav>
    </nav>
  </header>
</template>

<script>
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'SiteHeader',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  watch: {
    $route() {
      this.menuOpen = false;
    },
  },
  data() {
    return {
      bars: faBars,
      close: faTimes,
      menuOpen: false,
      subMenuOpen: {},
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    toggleSubMenu(menu, state) {
      if (window.innerWidth < 992) {
        return;
      }
      this.subMenuOpen[menu] = state;
      this.$forceUpdate();
    },
  },
};
</script>
